import React from "react";
import { useHistory } from "react-router-dom";
import { useGlobalContext } from "../../providers/context";

const NavbarLogout = () => {
  const { setStateGlobal } = useGlobalContext();

  const history = useHistory();

  const logout = () => {
    setStateGlobal({ usuario: {} });

    localStorage.clear();

    history.push("/login");
  };

  return (
    <>
      <li>
        <a href="#!" onClick={(e) => logout()}>
          <i className="fa fa-sign-out logout"></i>{" "}
          <span className="logout">Sair</span>
        </a>
      </li>
    </>
  );
};

export default NavbarLogout;
